var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lab_test__pdf"},[_c('embed',{staticClass:"pdfContainer",attrs:{"type":"application/pdf","src":_vm.pdfLink,"height":"100%","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }